import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/tennis';
const recap = ['6 volymer', '5 bonusar', '240 sidor', 'Alla nivåer'];
const reassurances = ['Omedelbar digital nedladdning', 'Utskrivbara PDF-filer', '7 dagars nöjdhetsgaranti'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15bsp5nr0okn9">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbk90547sv96" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1ec7kzh1lxi50">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t1n1833ii56g">
          Din tennisträning kan vara <em className="text-red-700" data-id="element-118" data-mp="1o67o5ddbwdb3">redo redan idag.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="2245wo24yxfio">
          I stället för att leta efter övningar, skapa varje pass själv och lägga kvällarna
          på planering har du ett organiserat tränarsystem för hela säsongen. Mer tid till det som
          verkligen betyder något:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="s6ijx7hdt4kh">
          Dina spelare. Din träning. Ditt liv utanför banan.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="124g7dsrf2xc1">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="1b3jst3e23otp">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1b28n2y11w6zy">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1furz3qk3au2n">Engångsbetalning – ingen prenumeration.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1ksth085s4ncj">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1pszgubm7dg5p" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1pqd0bmhc3qbc">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="3qu5p05j9njo1">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="3qskwelgiiast" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}